<template>
    <div class="page-container has-breadcrumb">
        <div class="px-8 md:px-5 py-5 ">
            <breadcrumb></breadcrumb>
        </div>

        <div class="px-8 md:px-5 py-5 ">
            <h1 v-if="isAdding" class="mb-6">
                New Client
            </h1>
            <h1 v-else class="mb-6">
                Edit Client
            </h1>
            <client-form :clientID="$route.params.clientID"></client-form>
        </div>
    </div>
</template>

<script charset="utf-8">
    import Vuex from 'vuex';
    import ClientForm from './form/ClientForm.vue';
    import Breadcrumb from './includes/Breadcrumb.vue';


    export default {
        name: 'ClientsDetail',

        components: {
            ClientForm,
            Breadcrumb
        },

        created: function () {
            let params = this.$router.currentRoute.value;
            if(params.clientID){
                this.getClient({clientID: params.clientID}).then(data => {
                    this.setPaths([
                        {
                            text: 'Sharp Admin',
                            name: 'adminClients'
                        },
                        {
                            text: data.name,
                            name: 'adminClientsEdit',
                            params: { clientID: data.id }
                        },
                        {
                            text: 'Edit',
                            isText: true
                        },
                    ]);
                });
            }else{
                this.setPaths([
                    {
                        text: 'Sharp Admin',
                        name: 'adminClients'
                    },
                    {
                        text: 'New Client',
                        name: 'adminClientsAdd',
                        isText: true
                    }
                ]);
            }
        },


        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),
            isAdding: function () {
                return !this.$router.currentRoute.value.params.clientID;
            },
        },


        methods: {
            ...Vuex.mapActions('accounts', {
                getClient: 'getClient'
            }),
            ...Vuex.mapMutations('layout', {
                setPaths: 'setPaths',
            }),
        }
    }
</script>
